import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="200"
    fill="none"
    viewBox="0 0 548 534"
  >
  <path d="M162 222C217.228 222 262 177.228 262 122C262 66.772 217.228 22 162 22C106.772 22 62 66.772 62 122C62 177.228 106.772 222 162 222Z" stroke="currentColor" strokeWidth="24" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M12 522V452C12 380.203 79.157 322 162 322C202 322 237 337 262 362" stroke="currentColor" strokeWidth="24" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M386 172C430.183 172 466 136.183 466 92C466 47.817 430.183 12 386 12C341.817 12 306 47.817 306 92C306 136.183 341.817 172 386 172Z" stroke="currentColor" strokeWidth="24" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M536 522V422C536 366.772 491.228 322 436 322H412" stroke="currentColor" strokeWidth="24" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgIcon;
